if (!customElements.get('naturalist-hotspot')) {
  customElements.define('naturalist-hotspot', class extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.naturalist-hotspot__trigger');
      this.card = this.querySelector('.naturalist-hotspot__card');
      this.querySelector('select')?.addEventListener('change', (event) => {
        const minimum = event.target.selectedOptions[0].dataset.minimum || '1';
        this.querySelector('[name="quantity"]').value = minimum;
      });
      this.onOutside = (event) => { if (!this.contains(event.target)) this.close(); };
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.open();
      });
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' && !this.pinned && !this.contains(document.activeElement)) this.close();
      });
      this.trigger.addEventListener('click', () => {
        if (this.pinned) this.close();
        else { this.open(); this.pinned = true; }
      });
      this.querySelector('.naturalist-hotspot__close').addEventListener('click', () => {
        this.close(); this.trigger.focus();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { this.close(); this.trigger.focus(); event.stopPropagation(); }
      });
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (!this.contains(document.activeElement) && !this.matches(':hover')) this.close(); });
      });
      document.addEventListener('pointerdown', this.onOutside);
    }
    disconnectedCallback() {
      this.fade?.cancel();
      document.removeEventListener('pointerdown', this.onOutside);
    }
    open() {
      this.parentElement.querySelectorAll('naturalist-hotspot[data-open]').forEach((hotspot) => {
        if (hotspot !== this) hotspot.close();
      });
      const wasHidden = this.card.hidden;
      const opacity = wasHidden ? 0 : Number(getComputedStyle(this.card).opacity);
      this.fade?.cancel();
      this.card.hidden = false;
      this.card.inert = false;
      this.fade = this.card.animate([{ opacity }, { opacity: 1 }], {
        duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220,
        easing: 'ease-out', fill: 'forwards'
      });
      this.setAttribute('data-open', '');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.card.style.marginLeft = '0px';
      const bounds = this.card.getBoundingClientRect();
      const shift = bounds.left < 16 ? 16 - bounds.left : Math.min(0, window.innerWidth - 16 - bounds.right);
      this.card.style.marginLeft = `${shift}px`;
    }
    close() {
      this.pinned = false;
      if (this.card.hidden) return;
      const opacity = Number(getComputedStyle(this.card).opacity);
      this.fade?.cancel();
      this.card.inert = true;
      const fade = this.card.animate([{ opacity }, { opacity: 0 }], {
        duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180,
        easing: 'ease-in', fill: 'forwards'
      });
      this.fade = fade;
      fade.finished.then(() => {
        if (this.fade === fade) this.card.hidden = true;
      }).catch(() => {});
      this.removeAttribute('data-open');
      this.trigger.setAttribute('aria-expanded', 'false');
    }
  });
}
